import React, { useCallback, useState } from 'react';

import { Box, Grid, TextField, Typography } from '@material-ui/core';

import FloatingButton from '../../../../../../components/FloatingButton';
import Loader from '../../../../../../components/LoaderSplash/Loader.component';
import { NumberFormatCustom } from '../../../../../../components/NumberFormartCustom/NumberFormatCustom.component';
import { useSinisterInspectionsContext } from '../../../../../../context/SinisterInspections/SinisterInspections.provider';
import useForm from '../../../../../../helpers/useForm';
import SelectMechanicalWorkshopValidations from './Step1.validations';

const Step1 = () => {
  const {
    loading,
    step,
    goBack,
    nextStep,
    updateSinisterInspectionBody,
    sinister_inspection_body,
  } = useSinisterInspectionsContext();

  const [defaultValues, setDefaultValues] = useState({
    name: sinister_inspection_body?.name || '',
    email: sinister_inspection_body?.email || '',
    phone_number: sinister_inspection_body?.phone_number || '',
  });

  const callNextStep = useCallback(
    (values: any) => {
      if (values.name && values.email && values.phone_number) {
        updateSinisterInspectionBody({
          ...values,
        });
        nextStep();
      }
    },
    [nextStep, updateSinisterInspectionBody]
  );

  const { values, errors, handleChange, handleSubmit } = useForm(
    callNextStep,
    SelectMechanicalWorkshopValidations,
    defaultValues
  );

  return (
    <>
      <Box display={loading ? 'block' : 'none'}>
        <Loader action={'Cargando información'}></Loader>
      </Box>

      <Grid container justify="center">
        <Grid item xs={12}>
          <Box my={4}>
            <Typography variant="h6">Taller donde se inspeccionará</Typography>
          </Box>
        </Grid>
      </Grid>

      <Grid container>
        <Grid item xs={11} md={5}>
          <Box mb={2}>
            <Typography variant="subtitle2"> Nombre del taller * </Typography>
            <TextField
              type="text"
              size="small"
              error={Boolean(errors['name'])}
              helperText={errors['name']}
              onChange={handleChange}
              fullWidth={true}
              name="name"
              id="name"
              placeholder="Ingresá nombre del taller"
              variant="outlined"
              value={values.name}
            />
          </Box>

          <Box mb={2}>
            <Typography variant="subtitle2">Email *</Typography>
            <TextField
              type="email"
              size="small"
              error={Boolean(errors['email'])}
              helperText={errors['email']}
              onChange={handleChange}
              fullWidth={true}
              name="email"
              id="email"
              placeholder="Ingresá el email del taller"
              variant="outlined"
              value={values.email}
            />
          </Box>

          <Box mb={2} mt={2}>
            <Typography variant="subtitle2">Teléfono *</Typography>
            <TextField
              type="number"
              size="small"
              error={Boolean(errors['phone_number'])}
              helperText={errors['phone_number']}
              onChange={handleChange}
              fullWidth={true}
              name="phone_number"
              id="phone_number"
              placeholder="Ingresá el teléfono"
              variant="outlined"
              value={values.phone_number}
              InputProps={{
                inputComponent: NumberFormatCustom as any,
              }}
            />
          </Box>
        </Grid>
      </Grid>

      <Grid container justify="center">
        <Grid item xs={12}>
          <Box my={4}>
            <FloatingButton
              onClick={handleSubmit}
              disabled={
                !!Object.keys(errors).length ||
                !values.name ||
                !values.email ||
                !values.phone_number
              }
            >
              Continuar
            </FloatingButton>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default Step1;
